function sortProcesses(data, definedSortOrder, defaultSortOrder) {
    if (definedSortOrder && definedSortOrder.length > 0) {
        const definedSet = new Set(definedSortOrder);

        const definedSorted = definedSortOrder
            .map(code => data.find(process => process.code === code.trim()))
            .filter(Boolean);

        const remainingProcesses = data.filter(process => !definedSet.has(process.code));

        return [...definedSorted, ...applyDefaultSort(remainingProcesses, defaultSortOrder)];
    }

    return applyDefaultSort(data, defaultSortOrder);
}

function applyDefaultSort(data, sortOrder) {
    switch (sortOrder) {
        case 'Process Code Asc':
            return data.sort((a, b) => a.code.localeCompare(b.code));
        case 'Process Name Asc':
            return data.sort((a, b) => a.text.localeCompare(b.text));
        case 'Process Code Desc':
            return data.sort((a, b) => b.code.localeCompare(a.code));
        case 'Process Name Desc':
            return data.sort((a, b) => b.text.localeCompare(a.text));
        default:
            return data;
    }
}

export default sortProcesses;
